module.exports = __webpack_public_path__ + "static/media/header_courier.2f5ec30b.jpg";